module.exports = __webpack_public_path__ + "img/129.6.6fef7bd3.png";